import { useAbility } from "@casl/react";
import { Box } from "@mui/material";
import { AbilityContext } from "../../permission/Can";
import { Actions, Subjects } from "../../permission/constants";
import VisitorMenu from "./VisitorMenu";
import LoggedMenu from "./LoggedMenu";

const UserMenu = () => {
  const ability = useAbility(AbilityContext);

  return (
    <Box>
      {!ability.can(Actions.VIEW, Subjects.SIGN_UP_BUTTON) ? (
        <LoggedMenu aria-label="LoggedMenu" />
      ) : (
        <VisitorMenu aria-label="VisitorMenu" />
      )}
    </Box>
  );
};

export default UserMenu;
